import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ContactPage.css';

const reviews = [
  { college: 'PSG College of Technology', rating: 5, text: 'Cryptera 2025 was an incredible experience! The coding competitions were challenging and the workshops were very informative. Great organization and amazing prizes!' },
  { college: 'Anna University', rating: 5, text: 'One of the best tech symposiums I have attended. The PC building competition was thrilling and I learned so much from industry experts. Highly recommend!' },
  { college: 'NIT Trichy', rating: 4, text: 'Fantastic event with diverse technical and non-technical competitions. The venue was well-organized and the coordinators were very helpful throughout.' },
  { college: 'VIT Vellore', rating: 5, text: 'Cryptera 2025 exceeded my expectations! The programming contests were intense and the networking opportunities were invaluable. Can\'t wait for next year!' },
  { college: 'Coimbatore Institute of Technology', rating: 5, text: 'Being part of Cryptera was amazing! The energy, the competitions, and the overall atmosphere were outstanding. Proud to be from CIT!' }
];

const ContactPage = () => {
  const [currentReview, setCurrentReview] = useState(0);

  // Auto-rotate review content every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % reviews.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const nextReview = () => {
    setCurrentReview((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentReview((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  return (
    <section className="contact">
      <div className="space-bg"></div>
      <div className="spline-glow glow-1"></div>
      <div className="spline-glow glow-2"></div>
      <div className="grid-overlay"></div>
      <div className="particles-field"></div>
      <div className="container">
        <h2 className="neon-title">Get In Touch</h2>
        <div className="contact-content">
          <div className="contact-left">
            <div className="glass-panel reviews-card">
              <h3 className="panel-title">Is Cryptera 2025 Peak? Yes It Is!</h3>
              <div className="review-slider">
                <button className="review-nav prev" onClick={prevReview}>
                  <i className="fas fa-chevron-left"></i>
                </button>
                <div className="review-content">
                  <div className="review-stars">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`fas fa-star ${i < reviews[currentReview].rating ? 'active' : ''}`}></i>
                    ))}
                  </div>
                  <p className="review-text">"{reviews[currentReview].text}"</p>
                  <div className="review-author">
                    <p>{reviews[currentReview].college}</p>
                  </div>
                  <div className="review-dots">
                    {reviews.map((_, i) => (
                      <span key={i} className={`dot ${i === currentReview ? 'active' : ''}`} onClick={() => setCurrentReview(i)}></span>
                    ))}
                  </div>
                </div>
                <button className="review-nav next" onClick={nextReview}>
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div className="team-buttons">
              <Link to="/developers" className="btn team-btn developers-btn">
                <i className="material-icons-outlined">code</i>
                <span>Meet Our Developers</span>
                <div className="btn-glow"></div>
              </Link>
              <Link to="/coordinators" className="btn team-btn coordinators-btn">
                <i className="material-icons-outlined">groups</i>
                <span>Meet Our Coordinators</span>
                <div className="btn-glow"></div>
              </Link>
            </div>
          </div>
          <div className="contact-right-top">
            <div className="glass-panel contact-info-card">
              <h3 className="panel-title">Contact Information</h3>
              <div className="contact-phones">
                <div className="phone-item">
                  <i className="fas fa-user"></i>
                  <div>
                    <h4>Dhivakar B S</h4>
                    <a className="phone-number" href="tel:+918838598314">+91-8838598314</a>
                  </div>
                </div>
                <div className="phone-item">
                  <i className="fas fa-user"></i>
                  <div>
                    <h4>Shyam Rajan S</h4>
                    <a className="phone-number" href="tel:+918098145904">+91-8098145904</a>
                  </div>
                </div>
                <div className="phone-item">
                  <i className="fas fa-user"></i>
                  <div>
                    <h4>Harish Vardhan D</h4>
                    <a className="phone-number" href="tel:+919790016953">+91-9790016953</a>
                  </div>
                </div>
              </div>
              <div className="social-section">
                <h4 className="social-title">Follow Us</h4>
                <div className="social-links">
                  <a href="https://whatsapp.com/channel/0029VbBdGihGU3BO8u3NO62F" target="_blank" rel="noopener noreferrer" className="social-link whatsapp">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                  <a href="https://instagram.com/cryptera_2k26" target="_blank" rel="noopener noreferrer" className="social-link instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://youtube.com/@cryptera2k26?si=ADAM5mwIPfggDK8n" target="_blank" rel="noopener noreferrer" className="social-link youtube">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-right-tech">
            <div className="glass-panel tech-assistance-card">
              <h3 className="panel-title">Technical Assistance</h3>
              <div className="tech-contacts">
                <div className="tech-item">
                  <i className="fas fa-laptop-code"></i>
                  <div>
                    <h4>Balamurali S R</h4>
                    <a className="phone-number" href="tel:+919488443352">+91-9488443352</a>
                  </div>
                </div>
                <div className="tech-item">
                  <i className="fas fa-tools"></i>
                  <div>
                    <h4>Dharani J M</h4>
                    <a className="phone-number" href="tel:+919751883087">+91-9751883087</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-right-map">
            <div className="glass-panel venue-map-card">
              <h3 className="panel-title">Find Us</h3>
              <iframe
                title="Coimbatore Institute of Technology"
                className="venue-map-iframe"
                src="https://www.google.com/maps?q=11.0283259,77.0272806&z=16&output=embed"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;